import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cb1c177"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-muted" }
const _hoisted_2 = { class: "btn-text" }
const _hoisted_3 = { class: "btn-text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cancelar", -1))
const _hoisted_5 = { class: "text-white" }


import { ref } from 'vue';
import { AtomBadge, AtomProgressBar, AtomButton, AtomInput } from '@/components/atoms';
import MoleculeCard from './MoleculeCard.vue'
import type { ITab } from '@/types';
import MoleculeTabsDate from './MoleculeTabsDate.vue'

import { getLanguage } from "@/utils/locale";
import { messages } from "@/utils/i18n";
interface IDataCommission {
  text: string;
  value: string;
}

interface IProps {
  name?: string;
  row?: IDataCommission[],
  email?: string;
  iconBrand?: 'ZebraIcon' | 'DatalogicIcon' | 'BlueBirdIcon';
  badgeText?: string
  badgeColor?: string
  badgeTextColor?: string
  isProgress?: boolean
  progress?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeDataFilterColaborators',
  props: {
    name: {},
    row: {},
    email: {},
    iconBrand: {},
    badgeText: {},
    badgeColor: {},
    badgeTextColor: {},
    isProgress: { type: Boolean },
    progress: {}
  },
  setup(__props: any) {

let locale:string = messages[getLanguage()]['message'];  


const props = __props

const activeTab = ref<string>('2020');
const tabs = ref<ITab[]>([
  {
    label: '2020',
    value: '2020',
  },
  {
    label: '2021',
    value: '2021',
  },
  {
    label: '2022',
    value: '2022',
  },
  {
    label: '2023',
    value: '2023',
  },
  {
    label: '2024',
    value: '2024',
  },
  {
    label: '2025',
    value: '2025',
  },
  {
    label: '2026',
    value: '2026',
  }
  ,
  {
    label: '2027',
    value: '2027',
  }
]);
const activeTab2 = ref<string>('2020');
const tabs2 = ref<ITab[]>([
  {
    label: locale['goals_details']['jan'],
    value: '1',
  }, 
  {
    label: locale['goals_details']['feb'],
    value: '2',
  }, 
  {
    label: locale['goals_details']['mar'],
    value: '3',
  }, 
  {
    label: locale['goals_details']['apr'],
    value: '4',
  }, 
  {
    label: locale['goals_details']['may'],
    value: '5',
  }, 
  {
    label: locale['goals_details']['jun'],
    value: '6',
  }, 
  {
    label: locale['goals_details']['jul'],
    value: '7',
  }, 
  {
    label: locale['goals_details']['aug'],
    value: '8',
  }, 
  {
    label: locale['goals_details']['sep'],
    value: '9',
  }, 
  {
    label: locale['goals_details']['oct'],
    value: '10',
  }, 
  {
    label: locale['goals_details']['nov'],
    value: '11',
  }, 
  {
    label: locale['goals_details']['dec'],
    value: '12',
  }
]);

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_item = _resolveComponent("v-card-item")!

  return (_openBlock(), _createBlock(MoleculeCard, { class: "width-card w-100" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "pb-0"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t('message.goals.date_filter')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                class: "pt-0"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('message.goals.select')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "px-0" }, {
                default: _withCtx(() => [
                  _createVNode(MoleculeTabsDate, {
                    modelValue: activeTab.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
                    tabs: tabs.value
                  }, null, 8, ["modelValue", "tabs"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_col, { class: "px-0" }, {
                default: _withCtx(() => [
                  _createVNode(MoleculeTabsDate, {
                    modelValue: activeTab2.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeTab2).value = $event)),
                    tabs: tabs2.value
                  }, null, 8, ["modelValue", "tabs"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomButton), {
                    background: "transparent",
                    class: "btn-border text-bold w-100 text-sm pa-1 my-1"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('message.common.current_month')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(AtomButton), {
                    background: "transparent",
                    class: "btn-border text-bold w-100 text-sm pa-1 my-1"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('message.common.last_month')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomButton), {
                    background: "transparent",
                    class: "btn-border text-bold w-100 text-sm pa-1 my-1"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomButton), { class: "text-bold w-100 text-sm pa-1 my-1 btn-submit" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('message.common.apply')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})